import BaseModelAPI from '../BaseModelAPI';

export default class SubcontractGoodReceipt extends BaseModelAPI {
	static entity = 'newobject1954';
	static entityName = 'subcontractgoodreceipt';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.subcontractGoodReceiptNumber = '';
			this.subcontractRequestDeliveryId = '';
			this.subcontractRequestDelivery = {};
			this.documentStatusId = '';
			this.documentStatus = {};
			this.suratJalan = '';
			this.remarks = '';
			this.subcontractGoodReceiptDetail = []
			this.subcontractGoodReceiptSuggestionDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async printPdfCustom(this_, id) {
		return this_.$http.get(`${this.entityName}/printpdfcustom/` + id)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

}